export default __webpack_public_path__ + "static/media/Pic1.522c15ea.png";